<button type="button" class="provider-earnings-card sold-box" (click)="onCardClick()">
  <div class="earnings-top">
    <p class="text">
      <ion-icon name="logo-usd" aria-hidden="true"></ion-icon>
      <span>{{ titleText }}</span>
    </p>
    <p class="sold">
      <span class="currency">€</span>
      <span class="value">{{ amountMajor }}</span>
      <span class="cents">,{{ amountCents }}</span>
    </p>
  </div>

  <div class="earnings-divider" aria-hidden="true"></div>

  <div class="earnings-pending">
    <p class="earnings-pending__label">
      <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
      <span>{{ pendingLabelText }}</span>
    </p>
    <span class="earnings-pending__amount">{{ formattedPendingAmount }}</span>
  </div>

  <img *ngIf="balance > 0" class="image" src="/assets/icon/person.svg" alt="" />
  <div class="shape-1" aria-hidden="true"></div>
  <div class="shape-2" aria-hidden="true"></div>
  <div class="shape-3" aria-hidden="true"></div>
</button>
